/**
 * Query-key factory — the one vocabulary for cache keys and invalidation.
 * Keys are arrays: [family, ...detail]. Invalidate by family prefix.
 */

export const qk = {
  me: ['me'] as const,
  /** ZOY-351: uid in the key — a changed subject can never read the old snapshot. */
  authz: (uid: string, clinicId: string | null) => ['authz', uid, clinicId] as const,
  clinic: (clinicId: string) => ['clinic', clinicId] as const,
  /** The signed-in human's Auth profile — keyed on uid so a changed subject never reads another's name. */
  profile: (uid: string) => ['profile', uid] as const,
};
